import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-button_icon-27",
  "use": "icon-button_icon-27-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-button_icon-27\"><g stroke=\"currentColor\" fill=\"transparent\" stroke-width=\"1.5\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M7.91 14.106l2.584 3.267 5.415-5.476\" /><rect x=\"1.75\" y=\"4.75\" width=\"20.5\" height=\"15.5\" rx=\"2\" /><path d=\"M2 9.367h20.406\" /><path stroke-linecap=\"round\" d=\"M7.5 2.5v4M16.5 2.5v4\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol